<template>
    <prism-table :prisms="prisms" solution-key="deslocamento" />
</template>

<script>
import BPrismTable from "@/modules/simulator/components/BPrismTable";

export default {
    name: "VirtualPrismsTable",
    components: {
        PrismTable: BPrismTable
    },
    computed: {
        prisms() {
            return this.$store.state.julho_14.simulator.results.VirtualPrisms;
        }
    }
};
</script>
